import React, { useEffect, useState } from "react";
import "./ScoreBoard.scss";
import { useGameState } from "../../hooks/useGameState";
import { ScoreBoardItem } from "./ScoreBoardItem/ScoreBoardItem";
import { Counter } from "./ScoreBoardItem/Counter/Counter";
import { Timer } from "./Timer/Timer";
import { useTranslation } from "react-i18next";
import { saveHighscore } from "../../utils/highScores";

interface IProps {

}

export function ScoreBoard(props: IProps) {
    const { t } = useTranslation();
    const { points, playerId, level, gameState, setGameState } = useGameState();
    const [timerState, setTimerState] = useState<'running' | 'idle'>('idle');
    const handleTimerEnd = () => {
        saveHighscore(playerId, points, false);
        setGameState('game-over');
    }

    // Pause when you're playing and the points change
    useEffect(() => {
        if (gameState !== 'playing') return;
        setTimerState('idle');
    }, [gameState, points]);

    // Start when you start playing, stop when you stop playing
    useEffect(() => {
        if (gameState === 'playing') {
            setTimerState('running');
        } else {
            setTimerState('idle');
        }
    }, [level, gameState]);

    return (
        <div className="score-board-wrapper">
            <ScoreBoardItem title={t('game.level').toUpperCase()} titleOrientation={'left'} largeNumbers={true}>
                <Counter value={level} />
            </ScoreBoardItem>
            <ScoreBoardItem title={t('game.points').toUpperCase()} titleOrientation={'right'}>
                <Counter value={points} />
            </ScoreBoardItem>
            <ScoreBoardItem title={t('game.timer').toUpperCase()} titleOrientation={'left'}>
                <Timer
                    minutes={4}
                    onEnd={handleTimerEnd}
                    state={timerState}
                    setState={setTimerState}
                />
            </ScoreBoardItem>
        </div>
    )
}
